import { useAutoAnimate } from '@formkit/auto-animate/react'
import { cn } from '@/lib/utils'
import type { ReactNode } from 'react'

export function AnimatedList(props: { children: ReactNode; className?: string }) {
  const [ref] = useAutoAnimate<HTMLDivElement>()
  return (
    <div ref={ref} className={cn('flex flex-col', props.className)}>
      {props.children}
    </div>
  )
}
